export const FIXED_STICKY_FOOTER_HEIGHT = '85px';
export const FIXED_TOAST_HEIGHT = '50px';
